import { cloneDeep } from 'lodash';
import { useEmployeeSuggestionsService, EmployeeInput } from 'domain/shared/employee';
import { ValidationProps, FormFieldsData } from 'framework/form';

interface InterviewerEmployeeInputProps extends ValidationProps {
  source: string;
  label?: string;
  nameSource?: string;
  mapResults?: (employee: any) => void;
  defaultFilter?: Dictionary<object>;
  isVisible?: boolean | ((data: FormFieldsData) => boolean);
  disabled?: boolean | ((data: FormFieldsData) => boolean);
  props?: any;
  withContractors?: boolean;
  initialLabel?: string;
  onChangeCallback?: (values: FormFieldsData) => void;
  onInputChangeCallback?: (query: any) => void;
  valueDecorator?: (searchValue: string) => string;
}

const DecisionMakerEmployeeInput = (props: InterviewerEmployeeInputProps) => {
  const { advancedSearch } = useEmployeeSuggestionsService();

  const searchDecisionMakers = (filter: any) => {
    const searchFilter = cloneDeep(filter) as any;

    const searchStringFilter = searchFilter.filter.searchString
      ? {
          filterType: 'FILTER',
          property: 'searchString',
          operator: 'CT',
          value: searchFilter.filter.searchString.ct,
        }
      : null;

    return advancedSearch({
      filter: {
        filterType: 'FILTER_GROUP',
        condition: 'AND',
        filters: [
          {
            filterType: 'FILTER_GROUP',
            condition: 'OR',
            filters: [
              {
                filterType: 'FILTER',
                property: 'specification:peopleManagerSpecification',
                operator: 'EQ',
                value: true,
              },
              {
                filterType: 'FILTER',
                property: 'specification:isHrManager',
                operator: 'EQ',
                value: true,
              },
              {
                filterType: 'FILTER',
                property: 'specification:isStaffingCoordinator',
                operator: 'EQ',
                value: true,
              },
            ],
          },
          searchStringFilter,
        ].filter(Boolean),
      },
    } as any);
  };

  return <EmployeeInput searchRequest={searchDecisionMakers} {...props} />;
};

export default DecisionMakerEmployeeInput;
